import { gql } from '@apollo/client';

export const GET_ADMIN_LIST = gql`
    query ($input: GetAdminListDTO!) {
        getAdminList(input: $input) {
            message
            adminList {
                _id
                name
                email
                phone
                status
                role
            }
            pagination {
                total
                hasNextPage
            }
        }
    }
`;

export const GET_ADMIN = gql`
    query ($id: String!) {
        getAdmin(id: $id) {
            message
            admin {
                _id
                name
                email
                role
                status
            }
        }
    }
`;

export const GET_USER_PROFILE = gql`
    query Me {
        me {
            _id
            access
            address
            contacts {
                dialCode
                number
            }
            email
            firstName
            lastName
            profileImage
            profileImageUrl
            name
            role
        }
    }
`;
